<template>
  <modal name="relatedEventsModal" class="custom-modal" :width="'75%'" :height="'auto'"
         :scrollable="true" :pivotX="1.0" :pivot-y="0" :minWidth="900" :minHeight="900" @before-open="beforeOpen"
         :clickToClose="true">

    <div class="modal-padding">
      <div class="manage-related-events-container margin-side">
        <div class="row">
          <div class="col-md-6 page-title h2-text">Manage Related Events</div>
          <div class="col-md-6 noPaddingRight align-right-item">
            <div class="modal-close-img" @click="hideModal">
              <div class="icon-close"></div>
            </div>
          </div>
        </div>

        <ManageRelatedEvents v-if="eventId" :relatedEvents="relatedEvents" :currentEvent="currentEvent" :eventId="eventId"></ManageRelatedEvents>
      </div>
    </div>
  </modal>
</template>
<script>
  import {mapActions} from 'vuex';
  import 'vue-awesome/icons/search';
  import ManageRelatedEvents from '@/components/events/ManageRelatedEvents';

  export default {
    name: 'relatedEventsModal',
    components: {
      ManageRelatedEvents
    },
    props: {},
    data () {
      return {
        relatedEvents: [],
        currentEvent: null,
        eventId: -1
      }
    },
    methods: {
      hideModal () {
        this.$modal.hide('relatedEventsModal');
      },
      beforeOpen (params) {
        this.currentEvent = params.params;
        this.eventId = this.currentEvent.id;
        this.relatedEvents = this.currentEvent.relatedEvents;
      },
      ...mapActions({
        addOrRemoveRelatedEvents: 'ACTION_ADD_REMOVE_RELATED_EVENTS'
      })
    }
  }
</script>

<style lang="less" scoped>
@import '../../../styles/variables.less';


.custom-modal {
  background: rgba(0, 0, 0, 0.4);

  .modal-padding {
    padding-top: 24px;
    min-height: 100vh;
  }

  .modal-close-img {
    display: flex;
    justify-content: flex-end;

    &:hover{
      cursor: pointer;
    }
    .icon-close {
      margin: 1.5px 1.5px;
      width: 16px;
      height: 16px;
      color: @black-3;
      background-color: @black-3;
      -webkit-mask: url('../../../../static/img/action-close-black.svg') no-repeat center;
      mask: url('../../../../static/img/action-close-black.svg') no-repeat center;
      background: url('../../../../static/img/action-close-black.svg');
    }
  }
}
</style>



// WEBPACK FOOTER //
// RelatedEventsModal.vue?0f584c5b